/* TaskList.tsx generated by @compiled/babel-plugin v0.36.1 */
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./TaskList.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { fg } from '@atlaskit/platform-feature-flags';
import { messages } from './i18n';
import { useIntl } from 'react-intl-next';
var listStyles = null;
var taskListStyles = null;
var TaskListNew = function TaskListNew(_ref) {
  var listId = _ref.listId,
    children = _ref.children;
  var listSize = React.Children.count(children);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "data-task-list-local-id": "",
    "aria-label": formatMessage(messages.fieldsetLabel),
    className: ax(["_2mzuglyw _19bvidpf"])
  }, React.Children.map(children, function (child, idx) {
    var _ref2 = child.props,
      localId = _ref2.localId;
    return /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
      data: {
        listLocalId: listId,
        listSize: listSize,
        position: idx
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: idx,
      "data-task-local-id": localId || '',
      className: ax(["_19pk1b66"])
    }, child));
  }));
};
var TaskListOld = /*#__PURE__*/function (_PureComponent) {
  function TaskListOld() {
    _classCallCheck(this, TaskListOld);
    return _callSuper(this, TaskListOld, arguments);
  }
  _inherits(TaskListOld, _PureComponent);
  return _createClass(TaskListOld, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        listId = _this$props.listId,
        children = _this$props.children;
      var listSize = React.Children.count(children);
      if (!children) {
        return null;
      }

      // Data attributes are required for copy and paste from rendered content
      // to the editor to preserve the task.
      // This allows the editor to differentiate between numbered and ordered lists,
      // and action items, which all share the common `<li>` element.
      // The value of `data-task-local-id` should be discarded upon paste, with a
      // a new uuid generated by the editor for the cloned content.
      return /*#__PURE__*/React.createElement("div", {
        "data-task-list-local-id": "",
        className: ax(["_2mzuglyw _19bvidpf"])
      }, React.Children.map(children, function (child, idx) {
        var _ref3 = child.props,
          localId = _ref3.localId;
        return /*#__PURE__*/React.createElement(FabricElementsAnalyticsContext, {
          data: {
            listLocalId: listId,
            listSize: listSize,
            position: idx
          }
        }, /*#__PURE__*/React.createElement("div", {
          key: idx,
          "data-task-local-id": localId || '',
          className: ax(["_19pk1b66"])
        }, child));
      }));
    }
  }]);
}(PureComponent);
var TaskListNext = function TaskListNext(props) {
  if (fg('editor_a11y_group_around_action_items')) {
    return /*#__PURE__*/React.createElement(TaskListNew, props);
  }
  return /*#__PURE__*/React.createElement(TaskListOld, props);
};
export default TaskListNext;